// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__148yw","inputWrap":"Table_inputWrap__TGovy","col":"Table_col__191xJ","bmiTooltip":"Table_bmiTooltip__3jI6M"};